import React, { useState } from 'react';
export default function App() {
    const [togg, setTogg] = useState(false)
    const [page, setPage] = useState(false)
    return (
        <div className="ud-header top-0 left-0 z-40 flex w-full items-center bg-transparent">
            <div className="container">
                <div className="relative -mx-4 flex items-center justify-between">
                    <div className="w-60 max-w-full px-4">
                        <a href="/" className="navbar-logo block w-full py-5">
                            <img src="assets/images/logo/logo.png" alt="logo" className="header-logo w-full" />
                        </a>
                    </div>
                    <div className="flex w-full items-center justify-between px-4">
                        <div>
                            {togg ?
                                <button onClick={() => setTogg(false)} id="navbarToggler"
                                    className="absolute right-4 top-1/2 block -translate-y-1/2 rounded-lg px-3 py-[6px] ring-primary focus:ring-2 lg:hidden navbarTogglerActive">
                                    <span className="relative my-[6px] block h-[2px] w-[30px] bg-white"></span>
                                    <span className="relative my-[6px] block h-[2px] w-[30px] bg-white"></span>
                                    <span className="relative my-[6px] block h-[2px] w-[30px] bg-white"></span>
                                </button>
                                :
                                <button onClick={() => setTogg(true)} id="navbarToggler"
                                    className="absolute right-4 top-1/2 block -translate-y-1/2 rounded-lg px-3 py-[6px] ring-primary focus:ring-2 lg:hidden">
                                    <span className="relative my-[6px] block h-[2px] w-[30px] bg-white"></span>
                                    <span className="relative my-[6px] block h-[2px] w-[30px] bg-white"></span>
                                    <span className="relative my-[6px] block h-[2px] w-[30px] bg-white"></span>
                                </button>
                            }

                            <nav id="navbarCollapse"
                                className={togg ? "absolute right-4 top-full w-full max-w-[250px] rounded-lg bg-white py-5 shadow-lg lg:static lg:block lg:w-full lg:max-w-full lg:bg-transparent lg:py-0 lg:px-4 lg:shadow-none xl:px-6" : "absolute right-4 top-full hidden w-full max-w-[250px] rounded-lg bg-white py-5 shadow-lg lg:static lg:block lg:w-full lg:max-w-full lg:bg-transparent lg:py-0 lg:px-4 lg:shadow-none xl:px-6"}>
                                <ul className="blcok lg:flex">
                                    <li className="group relative">
                                        <a href="/"
                                            className="ud-menu-scroll mx-8 flex py-2 text-base text-dark group-hover:text-primary lg:mr-0 lg:inline-flex lg:py-6 lg:px-0 lg:text-white lg:group-hover:text-white lg:group-hover:opacity-70">
                                            Home
                                        </a>
                                    </li>
                                    <li className="group relative">
                                        <a href="#"
                                            className="ud-menu-scroll mx-8 flex py-2 text-base text-dark group-hover:text-primary lg:mr-0 lg:inline-flex lg:py-6 lg:px-0 lg:text-white lg:group-hover:text-white lg:group-hover:opacity-70">
                                            Serviços
                                        </a>
                                    </li>
                                    <li className="group relative">
                                        <a href="/sobre"
                                            className="ud-menu-scroll mx-8 flex py-2 text-base text-dark group-hover:text-primary lg:mr-0 lg:ml-7 lg:inline-flex lg:py-6 lg:px-0 lg:text-white lg:group-hover:text-white lg:group-hover:opacity-70 xl:ml-12">
                                            Sobre
                                        </a>
                                    </li>
                                    <li className="group relative">
                                        <a href="#"
                                            className="ud-menu-scroll mx-8 flex py-2 text-base text-dark group-hover:text-primary lg:mr-0 lg:ml-7 lg:inline-flex lg:py-6 lg:px-0 lg:text-white lg:group-hover:text-white lg:group-hover:opacity-70 xl:ml-12">
                                            Rastreio
                                        </a>
                                    </li>
                                    {/* <li className="group relative">
                                        <a href="#"
                                            className="ud-menu-scroll mx-8 flex py-2 text-base text-dark group-hover:text-primary lg:mr-0 lg:ml-7 lg:inline-flex lg:py-6 lg:px-0 lg:text-white lg:group-hover:text-white lg:group-hover:opacity-70 xl:ml-12">
                                            Comercial
                                        </a>
                                    </li> */}
                                    <li className="group relative">
                                        <a href="/blog"
                                            className="ud-menu-scroll mx-8 flex py-2 text-base text-dark group-hover:text-primary lg:mr-0 lg:ml-7 lg:inline-flex lg:py-6 lg:px-0 lg:text-white lg:group-hover:text-white lg:group-hover:opacity-70 xl:ml-12">
                                            Blog
                                        </a>
                                    </li>
                                    <li className="group relative">
                                        <a href="/contato"
                                            className="ud-menu-scroll mx-8 flex py-2 text-base text-dark group-hover:text-primary lg:mr-0 lg:ml-7 lg:inline-flex lg:py-6 lg:px-0 lg:text-white lg:group-hover:text-white lg:group-hover:opacity-70 xl:ml-12">
                                            Contatos
                                        </a>
                                    </li>
                                    
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

